import { AnchorIcon, MapPinIcon, UsersIcon } from "lucide-react";

interface VesselMetaChipsProps {
  homePort: string | null | undefined;
  flagState: string | null | undefined;
  berths: number | null | undefined;
  maxPassengers: number | null | undefined;
  currentExpedition: string | undefined;
}

export function VesselMetaChips({
  homePort,
  flagState,
  berths,
  maxPassengers,
  currentExpedition,
}: Readonly<VesselMetaChipsProps>) {
  return (
    <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-xs text-muted-foreground">
      {homePort && (
        <span className="inline-flex items-center gap-1.5">
          <MapPinIcon className="size-3" />
          {homePort}
        </span>
      )}
      {flagState && (
        <span className="inline-flex items-center gap-1.5">
          <AnchorIcon className="size-3" />
          {flagState}
        </span>
      )}
      {berths != null && (
        <span className="inline-flex items-center gap-1.5">
          <UsersIcon className="size-3" />
          {berths} berths{maxPassengers != null ? ` · ${maxPassengers} max` : ""}
        </span>
      )}
      {currentExpedition && (
        <span className="inline-flex items-center gap-1.5 text-shallow-600 dark:text-shallow-400">
          <span className="relative flex size-1.5">
            <span className="absolute inline-flex size-full animate-ping rounded-full bg-shallow-500 opacity-60" />
            <span className="relative inline-flex size-1.5 rounded-full bg-shallow-500" />
          </span>
          {currentExpedition}
        </span>
      )}
    </div>
  );
}
